module.exports = __webpack_public_path__ + "media/images/views/home/home-section-quem-somos-bottom-64f5a40d92e7babc29aa33345a40936a.png";